// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"659":"d82fb86f","721":"5266ec4f","932":"0c6661e7"}[chunkId] + ".chunk.css";
};